import { render, staticRenderFns } from "./ChooseRecycleDisposalPatternModal.vue?vue&type=template&id=cd5deb3c&scoped=true&"
import script from "./ChooseRecycleDisposalPatternModal.vue?vue&type=script&lang=js&"
export * from "./ChooseRecycleDisposalPatternModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRecycleDisposalPatternModal.vue?vue&type=style&index=0&id=cd5deb3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5deb3c",
  null
  
)

export default component.exports